import { ViewMode } from '@efdigital/ll-addon-codemirror';
import { PageWidgetType } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type {
  PageWidgetEmbedVideo,
  PageWidgetEmbedVideoLike,
} from '@efdigital/ll-addon-data/types/content/objects/page-widget-embed-video';
import { MarkdownEditorWithImagePicker } from '@efdigital/ll-admin-v2/components/markdown-editor-with-image-picker';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { SidebarAll } from '../../../lib/markdown-toolbar.ts';
import type {
  PageWidgetComponentSignature,
  WidgetEditor,
} from '../page-widget-signature.ts';

export class PageWidgetEmbedVideoComponent extends Component<PageWidgetComponentSignature> {
  get widget() {
    return this.args.widget as PageWidgetEmbedVideo;
  }

  setEmbed = (event: Event) => {
    const embed = (event.target as HTMLInputElement).value;
    this.widget.embed = embed;
  };

  setTranscript = (transcript: string) => {
    this.widget.transcript = transcript;
  };

  setShowTranscript = (event: Event) => {
    const showTranscript = (event.target as HTMLInputElement).checked;
    this.widget.showTranscript = showTranscript;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-embed">Embed code</label>
          <textarea
            class="form-control"
            id="{{uniqueId}}-embed"
            rows="5"
            value={{this.widget.embed}}
            {{on "change" this.setEmbed}}
          />
        </div>
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-transcript">Transcript</label>
          <MarkdownEditorWithImagePicker
            @markdown={{this.widget.transcript}}
            @toolbar={{SidebarAll}}
            @mode={{ViewMode.EditorOnly}}
            @onUpdate={{this.setTranscript}}
            @requiredSize="email-image"
          >
            <:preview as |markdown|>
              <pre>{{markdown}}</pre>
            </:preview>
          </MarkdownEditorWithImagePicker>
        </div>
        <div class="form-check mb-4">
          <input
            class="form-check-input"
            id="{{uniqueId}}-showTranscript"
            type="checkbox"
            checked={{this.widget.showTranscript}}
            {{on "change" this.setShowTranscript}}
          />
          <label class="form-check-label" for="{{uniqueId}}-showTranscript">Show
            Transcript</label>
        </div>
      </div>
    {{/let}}
  </template>
}

const DEFAULT_WIDGET_EMBED_VIDEO: Omit<PageWidgetEmbedVideoLike, 'wid'> = {
  widgetType: PageWidgetType.EmbedVideo,
  title: 'Video',
  css: '',
  embed: '',
  transcript: '',
  showTranscript: false,
};

export const EmbedVideoWidgetEditor: WidgetEditor = {
  icon: 'ph:video-bold',
  label: 'Video',
  component: PageWidgetEmbedVideoComponent,
  dataType: DataTypeContent.PageWidgetEmbedVideo,
  widgetData: DEFAULT_WIDGET_EMBED_VIDEO,
};
